import React, { useState, useEffect } from 'react';
import { FileText, Download } from 'lucide-react';
import { piApi } from '../../services/piApi';
import '../pi/PIShell.css';

export default function PILPPortal({ currentUser }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    loadLPData();
  }, []);

  async function loadLPData() {
    try {
      const [reportsRes, summaryRes] = await Promise.all([
        piApi.getLPReports(),
        piApi.getPortfolioSummary(),
      ]);
      setReports(reportsRes.data || []);
      setSummary(summaryRes.data || null);
    } catch (e) {
      console.error('[LP Portal]', e);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return (
    <div className="pi-loading" style={{ padding: 40 }}>
      <div className="pi-spinner" />
      <span>Loading your portfolio updates...</span>
    </div>
  );

  return (
    <div style={{ padding: '32px 40px', maxWidth: 860, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>
        Portfolio Updates
      </h1>
      <p style={{ color: '#64748b', fontSize: 13, marginBottom: 28 }}>
        Your latest reports from the portfolio management team.
      </p>

      {/* Fund-level summary */}
      {summary && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 32 }}>
          <div className="pi-stat-card">
            <div className="pi-stat-value">{summary.blendedIrr != null ? `${summary.blendedIrr}%` : '—'}</div>
            <div className="pi-stat-label">Fund IRR</div>
          </div>
          <div className="pi-stat-card">
            <div className="pi-stat-value">{summary.activePortcos ?? '—'}</div>
            <div className="pi-stat-label">Active Portfolio Companies</div>
          </div>
          <div className="pi-stat-card">
            <div className="pi-stat-value">{summary.lastReportDate || '—'}</div>
            <div className="pi-stat-label">Last Report Date</div>
          </div>
        </div>
      )}

      {/* Reports list */}
      <div className="pi-card">
        <div className="pi-card-header">
          <span className="pi-card-title">LP Reports</span>
        </div>
        {reports.length === 0 ? (
          <div className="pi-empty">
            <FileText size={32} style={{ opacity: 0.3 }} />
            <div className="pi-empty-title">No reports have been shared yet</div>
            <div className="pi-empty-sub">Your fund manager will share quarterly updates here when they are available.</div>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                {['Period', 'Portfolio Company', 'Sent', ''].map(h => (
                  <th key={h} style={{ padding: '10px 16px', textAlign: 'left', color: '#64748b', fontWeight: 500, fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reports.map(r => (
                <tr key={r.id} style={{ borderBottom: '1px solid #f8fafc' }}>
                  <td style={{ padding: '12px 16px', color: '#334155', fontWeight: 600 }}>{r.period}</td>
                  <td style={{ padding: '12px 16px', color: '#475569' }}>{r.portco?.name || '—'}</td>
                  <td style={{ padding: '12px 16px', color: '#64748b' }}>{r.approved_at ? new Date(r.approved_at).toLocaleDateString() : '—'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <button className="pi-btn-ghost" style={{ fontSize: 12, padding: '5px 10px' }}>
                      <Download size={13} /> Read
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
